import { isServer } from 'library/helpers/isServer';
import { env } from './env';

const devConfig = {
	apiKey: 'AIzaSyCe6wqnwwoQQVCeVShxxrxy38hdydIhzqs',
	authDomain: 'zezamii-dev.firebaseapp.com',
	projectId: 'zezamii-dev',
	storageBucket: 'zezamii-dev.firebasestorage.app',
	messagingSenderId: '195992418107',
	appId: '1:195992418107:web:2db28a3281f85676b2e91e'
};

const prodConfig = {
	apiKey: 'AIzaSyBVKXTuUmnd2bWzg5ASXjY8DQIyCytL5CA',
	authDomain: 'zezamii-3f2a8.firebaseapp.com',
	projectId: 'zezamii-3f2a8',
	storageBucket: 'zezamii-3f2a8.appspot.com',
	messagingSenderId: '661920598022',
	appId: '1:661920598022:web:0a5ab5f228d1a40c6a5b87',
	measurementId: 'G-VLW8Q8TNYV'
};

// remove local storage when environment changes from staging to production or development
const savedEnv = !isServer && localStorage.getItem('selectedEnvironment');
const appEnv = savedEnv || env.appEnv;

const firebaseConfig = appEnv === 'production' ? prodConfig : devConfig;

export default firebaseConfig;
